module.exports = __webpack_public_path__ + "static/media/grandExam.b8ae46a8.png";